import React from "react";
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  makeStyles,
} from "@material-ui/core";

function flattenAssignments(state) {
  return Object.entries(state).map(([doctorId, doctorProducts]) => ({
    doctorId,
    products: Object.values(doctorProducts)
      .filter((item) => Number(item.qty) > 0)
      .map((item) => ({ ...item, qty: Number(item.qty) })),
  }));
}

export default function AssignmentSummary({
  doctorsSelected,
  productsSelected,
  assignment,
}) {
  const classes = useStyles();
  const isInvalidData =
    !doctorsSelected || !productsSelected || !Object.keys(assignment).length;

  if (isInvalidData)
    return (
      <Card
        variant="outlined"
        style={{ flex: 1, marginTop: 12, maxHeight: "60vh", overflowY: "auto" }}
      >
        <CardContent style={{ padding: 12 }}>
          <Typography color="textSecondary">
            No tienes asignaciones pendientes.{" "}
          </Typography>
        </CardContent>
      </Card>
    );

  const groupedAssignments = flattenAssignments(assignment);

  const getDoctorName = (doctorId) =>
    doctorsSelected[doctorId]?.name || doctorId;

  const getProductName = (productId) =>
    productsSelected[productId]?.name || productId;

  const getMoleculeConcentration = (productId) => {
    const molecule = productsSelected[productId]?.molecule || "";
    const concentration = productsSelected[productId]?.concentration || "";

    return `${molecule} - ${concentration}`;
  };

  return (
    <Card
      variant="outlined"
      style={{ flex: 1, marginTop: 12, maxHeight: "60vh", overflowY: "auto" }}
    >
      <CardContent style={{ padding: 12 }}>
        {groupedAssignments.map(({ doctorId, products }, index) => (
          <div
            key={doctorId}
            style={{ marginBottom: "1rem" }}
            className={classes.card_doctor}
          >
            <Typography variant="subtitle1" color="primary">
              {getDoctorName(doctorId)}
            </Typography>
            <Divider className={classes.divider_name_list} />
            <List dense style={{ padding: 0 }}>
              {products.map((item, idx) => (
                <React.Fragment key={item.productId}>
                  <ListItem>
                    <ListItemText
                      style={{ padding: 0, margin: 0 }}
                      primary={
                        <Box
                          component={"span"}
                          className={classes.table_sub_item}
                        >
                          <Box component={"span"}>
                            <Typography
                              component={"span"}
                              style={{ display: "flex" }}
                            >
                              {getProductName(item.productId)}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="textPrimary"
                              style={{ marginTop: "-4px", display: "flex" }}
                            >
                              {getMoleculeConcentration(item.productId)}
                            </Typography>
                          </Box>
                          <Typography component={"span"}>{item.qty}</Typography>
                        </Box>
                      }
                    />
                  </ListItem>
                  {idx < products.length - 1 && <Divider component="li" />}
                </React.Fragment>
              ))}
              {!products.length && (
                <ListItem>
                  <ListItemText primary="No tienes asignaciones pendientes."></ListItemText>
                </ListItem>
              )}
            </List>
            {index < groupedAssignments.length - 1 && <Divider />}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles((theme) => ({
  card_doctor: {
    backgroundColor: `hsl(from ${theme.palette.primary.light} h s calc(l + 54))`,
    padding: 8,
    borderRadius: 8,
  },
  table_sub_item: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "end",
  },
  divider_name_list: {
    backgroundColor: theme.palette.info.dark,
  },
}));
